import { mutationFor } from "@visioni/a3s-client-api/app";
import { openGateEndpoint } from "../client-messages/commands";

export const openGateMutation = mutationFor(openGateEndpoint);
